import type { PatentLayoutRequestType, PatentLayoutResponseType } from './patent-layout-api'

export interface IPatentLayoutV2Api {
    getLayoutByPatent: (params: PatentLayoutRequestType) => Promise<PatentLayoutResponseType>
}

export const IPatentLayoutV2Api = Symbol('IPatentLayoutV2Api')
